module.exports = __webpack_public_path__ + "static/media/MR.ecdaad94.png";